import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Phone, Menu, X, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/properties", label: "Properties" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { settings, waLink, telLink } = useSettings();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-xl border-b border-gray-100" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            {settings?.logo_url ? (
              <img src={settings.logo_url} alt={settings?.brand_name || "Mathura Homes"} className="h-11 md:h-14 w-auto object-contain" />
            ) : (
              <span className="font-display text-2xl font-bold text-navy">Mathura Homes</span>
            )}
            <span className="hidden sm:flex flex-col leading-tight">
              <span className="font-display text-lg md:text-xl font-bold text-navy">{settings?.brand_name || "Mathura Homes"}</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) => `text-sm font-semibold transition-colors hover:text-gold ${isActive ? "text-gold" : "text-navy"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a href={telLink()} data-testid="header-call-btn" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-navy text-navy text-sm font-semibold hover:bg-navy hover:text-white transition-colors">
              <Phone className="w-4 h-4" strokeWidth={1.5} /> Call Now
            </a>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="header-whatsapp-btn" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-whatsapp text-white text-sm font-semibold hover:opacity-90 transition-opacity">
              <MessageCircle className="w-4 h-4" strokeWidth={1.5} /> WhatsApp
            </a>
          </div>

          <button className="lg:hidden p-2 text-navy" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-1">
            {NAV.map((n) => (
              <button key={n.to} onClick={() => { navigate(n.to); setOpen(false); }} data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className="block w-full text-left px-3 py-3 rounded-lg text-navy font-semibold hover:bg-muted">
                {n.label}
              </button>
            ))}
            <div className="flex gap-3 pt-3">
              <a href={telLink()} className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg border border-navy text-navy text-sm font-semibold">
                <Phone className="w-4 h-4" /> Call
              </a>
              <a href={waLink()} target="_blank" rel="noreferrer" className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-whatsapp text-white text-sm font-semibold">
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
